<app-collapsible-container
    *ngIf="userType !== userTypeEnum.STUDENT"
    [id]="'userSettings'"
    [title]="'REPERTOIRE.FORMS.SETTINGS.ADULT.TITLE'"
    [icon]="'i-cog'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <div class="form-control">
        <app-switch-input
            [formControl]="notification"
            [label]="'REPERTOIRE.FORMS.SETTINGS.ADULT.NOTIFICATIONS-LABEL'"
            [title]="'REPERTOIRE.FORMS.SETTINGS.ADULT.NOTIFICATIONS-TITLE'"
            [readOnly]="readOnly"
        >
        </app-switch-input>
    </div>

    <div class="form-control">
        <app-switch-input
            [formControl]="msgCopyByMail"
            [label]="'REPERTOIRE.FORMS.SETTINGS.ADULT.MESSAGES-LABEL'"
            [title]="'REPERTOIRE.FORMS.SETTINGS.ADULT.MESSAGES-TITLE'"
            [readOnly]="readOnly"
        >
        </app-switch-input>
    </div>
</app-collapsible-container>

<app-collapsible-container
    *ngIf="userType === userTypeEnum.STUDENT"
    [id]="'studentSettings'"
    [title]="'REPERTOIRE.FORMS.SETTINGS.STUDENT.TITLE'"
    [icon]="'i-cog'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <div class="form-control">
        <app-switch-input
            [formControl]="isParentDivorced"
            [label]="'REPERTOIRE.FORMS.SETTINGS.STUDENT.FEES-REPARTITION-LABEL'"
            [title]="'REPERTOIRE.FORMS.SETTINGS.STUDENT.FEES-REPARTITION-TITLE'"
            [readOnly]="readOnly"
        >
        </app-switch-input>
    </div>
    <ng-container
        *ngIf="
            isParentDivorced.value === true &&
            ((parents.length <= 2 && (connectedUserType$ | async) === userTypeEnum.PARENT) ||
                (parents.length === 2 && (connectedUserType$ | async) !== userTypeEnum.PARENT))
        "
    >
        <div class="form-control" *ngIf="costsRepartition.value === 1 && parents.length > 0">
            <app-switch-input
                [formControl]="isParentsAuthorized"
                [label]="'REPERTOIRE.FORMS.SETTINGS.STUDENT.PARENT-AUTHORIZED-EDIT-LABEL'"
                [title]="'REPERTOIRE.FORMS.SETTINGS.STUDENT.PARENT-AUTHORIZED-EDIT-TITLE'"
                [readOnly]="readOnly"
            >
            </app-switch-input>
        </div>

        <div class="form-control">
            <app-generic-radio-checkbox
                [config]="{
                    formGroupName: 'costsRepartition',
                    inputType: 'radio',
                    questionChoices: costsRepartitionChoices$ | async
                }"
                [formControl]="costsRepartition"
                [readOnly]="readOnly"
            >
            </app-generic-radio-checkbox>
        </div>

        <div *ngIf="costsRepartition.value === 2" class="form-control">
            <div class="horizontal">
                <div *ngFor="let parent of parents; let i = index" class="horizontal">
                    <p class="parent-color{{ i }}"></p>
                    <p class="parent-name{{ i }}">{{ parent.firstname }} {{ parent.lastname }}</p>
                    <p class="parent-ratio">{{ parent.id === parent1Id.value ? repartitionRatio1.value : repartitionRatio2.value }} %</p>
                </div>
            </div>
            <ngx-slider
                *ngIf="parents.length > 0"
                [formControl]="parent1Id.value === parents[0].id ? repartitionRatio1 : repartitionRatio2"
                [options]="{ floor: 0, ceil: 100, step: 5, readOnly: readOnly }"
                readonly="true"
            >
            </ngx-slider>
        </div>

        <div *ngIf="costsRepartition.value === 1" class="form-control">
            <div class="horizontal">
                <a (click)="goCalendar()" class="btn btn--primary">{{
                    ((connectedUserType$ | async) === userTypeEnum.PARENT && (userToEdit$ | async).settings.parents_authorized === false
                        ? 'REPERTOIRE.FORMS.SETTINGS.STUDENT.CALENDAR-VIEW-LINK'
                        : 'REPERTOIRE.FORMS.SETTINGS.STUDENT.CALENDAR-EDIT-LINK'
                    ) | translate
                }}</a>
            </div>
        </div>
    </ng-container>
    <div class="error-message" *ngIf="errorCustodies">
        <p class="error">{{ 'GARDES.ERROR_FORM_CUSTODY' | translate }}</p>
    </div>
    <ng-container *ngIf="isParentDivorced.value === true && parents.length === 1 && (connectedUserType$ | async) !== userTypeEnum.PARENT">
        <div class="disclaimer big">
            {{ 'REPERTOIRE.FORMS.SETTINGS.STUDENT.NOT-ENOUGH-PARENT' | translate }}
        </div>
    </ng-container>
    <ng-container *ngIf="isParentDivorced.value === true && parents.length === 0">
        <div class="disclaimer big">
            {{ 'REPERTOIRE.FORMS.SETTINGS.STUDENT.NO-PARENT-SELECTED' | translate }}
        </div>
    </ng-container>
    <!-- IF MORE THAN 2 PARENTS SELECTED-->
    <ng-container *ngIf="isParentDivorced.value === true && parents.length > 2">
        <div class="disclaimer big">
            {{ 'REPERTOIRE.FORMS.SETTINGS.STUDENT.TOO-MANY-PARENT' | translate }}
        </div>
    </ng-container>
</app-collapsible-container>
